import { CircularProgress, CircularProgressProps, Stack } from "@mui/material";

export const LoadingIndicator = (props: CircularProgressProps) => {
  return (
    <Stack sx={{ flexGrow: 1, width: "100%", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress color="secondary" {...props} />
    </Stack>
  );
};
